import React from 'react';
import Anchor from '../../components/form-elements/Anchor';


function MoreProductsSlider({ children }) {
    
    return (
        <>

            <div className="uk-padding uk-slider uk-padding-remove-bottom custom-slider" data-uk-slider="finite: true" style={{ background: 'var(--grey-light-main, #e0e0e0)', padding: 20}}>
                <div className="uk-position-relative" tabIndex={-1}>
                    <ul
                        className="uk-slider-items uk-grid uk-grid-match uk-child-width-1-2@s uk-child-width-1-2@m"
                    >
                        {children}
                    </ul>
                    <div className="uk-flex uk-flex-center uk-margin-small-top uk-margin-small-bottom">
                        <Anchor
                            className="uk-icon-button custom-nav"
                            data-uk-slider-item="previous"
                            ariaLabel="Vorheriger Slide"
                            role="button"
                            tabIndex="0"
                        >
                            <i data-uk-slidenav-previous="" aria-hidden="true" className='slide-arrow' />
                        </Anchor>

                        <Anchor
                            className="uk-icon-button custom-nav uk-margin-small-left"
                            data-uk-slider-item="next"
                            ariaLabel="Nächster Slide"
                            role="button"
                            tabIndex="0"
                        >
                            <i data-uk-slidenav-next="" aria-hidden="true" className='slide-arrow' />
                        </Anchor>
                    </div>
                </div>
            </div>


        </>


    )
}

export default MoreProductsSlider;